import React, { useRef, useState } from "react";
import Modal from "components/base/Modal";
import css from "./style.scss";
import Checkbox from 'components/base/Checkbox';
import CheckboxItem from "components/Checkbox";
import rewardicon from "../../../assets/images/rewardicon.svg";
import plusicon from "../../../assets/images/plusicon.svg";
import infoicon from "../../../assets/images/infoicon.svg";
import CreditCardDropdown from "../../AccountNew/components/CreditCardDropdown";
import { useSelector } from "react-redux";
import { selectCardList } from "../../../data/user";
import AddPaymentPopup from "../../AccountNew/modals/AddPayment";
import { connect, useDispatch } from "react-redux";
import Tooltip from "../Tooltip";
import { selectDirectMailCostPreview } from "../../../data/campaigns/selectors";
import Loader from "../../../components/Loader";
import { selectPrimaryUserId } from "../../../data/user";
import config from "config";
import Button from "components/base/Button";
import { set } from "lodash";
import LoaderModal from "../LoaderModal";
import CVV99Modal from "app/AccountNew/components/cvv99Modal";

const CampaginPaymentModal = ({
    isOpen,
    onClose,
    openAddPaymentPopup,
    iFrameMessageHandlerRef,
    isLoading
}) => {

    const {
        constants: {
            API: { PRICING_UPDATE_URL },
        },
    } = config;

    const cardList = useSelector(selectCardList);
    const [selectedCard, setSelectedCard] = useState(null);
    const [isChecked, setIsChecked] = useState(false);
    const [isPlacingOrder, setIsPlacingOrder] = useState(false);
    const [showCVVModal, setShowCVVModal] = useState(false);
    const chargedOrderIdsRef = useRef(new Set());

    const primaryUserId = useSelector(selectPrimaryUserId);

    const buildOrderDetails = (data) => {
        if (!data) return [];
        const rows = [];

        if (data.campaignType === "SINGLE") {
            const order = data.orders[0];

            rows.push(
                {
                    label: "Total Mailers",
                    value: order.billablePieceCount,
                },
                {
                    label: "Price Per Piece",
                    value: `$${order.unitPrice.toFixed(2)}`,
                }
            );
        }

        if (data.campaignType === "MULTI") {
            data.orders.forEach((order, index) => {
                rows.push(
                    { label: `Mail ${order.dropIndex + 1}`, isHeader: true },
                    { label: `Mailer`, value: order.billablePieceCount },
                    { label: "Remove Duplicates", value: `-${order.removedDuplicates}` },
                    { label: "Opt Out Leads", value: order.optOutLeads },
                    { label: "Price Per Piece", value: `$${order.unitPrice.toFixed(2)}` }
                );
            });
        }

        if (data.campaignType === "SPLIT") {
            data.orders.forEach((order) => {
                rows.push(
                    { label: `Variant ${order.variant}`, isHeader: true },
                    { label: "Total Mailers", value: order.billablePieceCount },
                    { label: "Price Per Piece", value: `$${order.unitPrice.toFixed(2)}` }
                );
            });
        }

        return rows;
    };

    const orderData = useSelector(selectDirectMailCostPreview)?.toJS();

    if (isLoading || !orderData) {
        return (
            <LoaderModal isOpen={isOpen} />
        );
    }

    const orderRows = buildOrderDetails(orderData);

    const totalMailers = orderData.orders.reduce(
        (total, order) => total + order.billablePieceCount,
        0
    );

    const hidePaymentSection = Number(orderData?.dueToday || 0) <= 0;

    const isPlaceOrderDisabled =
        orderData.campaignType === "MULTI" &&
        !hidePaymentSection &&
        !isChecked;

    const handlePlaceOrder = async () => {
        if (Number(orderData.dueToday) > 99) {
            setShowCVVModal(true);
            return;
        }

        await processPayment();
    };

    const processPayment = async (cardCode = null) => {
        setIsPlacingOrder(true);

        try {
            // Only charge orders that are chargeable today and haven't already been
            // successfully charged in a previous attempt (e.g. a retry after one
            // order in an A/B split succeeded but the other failed).
            const ordersToCharge = orderData.orders.filter(
                (order) =>
                    order.isChargeableToday &&
                    !chargedOrderIdsRef.current.has(order.directmailOrderId)
            );

            for (const order of ordersToCharge) {
                const response = await fetch(
                    `${PRICING_UPDATE_URL}/billing/directmail/charge`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "x-auth-token": window.appAuthToken,
                        },
                        body: JSON.stringify({
                            directMailCampaignId: Number(orderData.directMailCampaignId),
                            directmailOrderId: Number(order.directmailOrderId),
                            clientDeclaredTotalCost: Number(order.chargeableAmount),
                            paymentMethodId: Number(selectedCard?.paymentMethodId),
                            ...(cardCode && { cardCode: Number(cardCode) }),
                        }),
                    }
                );

                const data = await response.json();

                if (!response.ok || data.orderStatus !== "PAID") {
                    throw data;
                }

                chargedOrderIdsRef.current.add(order.directmailOrderId);
            }

            chargedOrderIdsRef.current.clear();

            iFrameMessageHandlerRef.current?.sendMessage("payment_result", {
                tenantKey: String(primaryUserId),
                status: "success",
            });

            onClose();
        } catch (err) {
            console.error(err);

            iFrameMessageHandlerRef.current?.sendMessage("payment_result", {
                tenantKey: String(primaryUserId),
                status: "failed",
            });

            onClose();
        } finally {
            setIsPlacingOrder(false);
        }
    };

    const handleSubmitCVV = ({ cardCode }) => {
        setShowCVVModal(false);
        processPayment(cardCode);
    };

    return (
        <Modal
            isOpen={isOpen}
            isCloseButton={false}
            uniqId="CampaginPaymentModal"
            width="auto"
            borderRadius="12px"
            modalClassName={css.campaignPaymentModal}
            onClose={onClose}
        >
            <div className={css.modalContainer}>
                <div className={css.headerTxt}>
                    Review & Place Order
                </div>

                <div className={css.content}>
                    <div className={css.leftPanelView}>
                        {/* LEFT PANEL */}
                        <div className={css.leftPanel}>
                            <div className={css.paymentSection}>
                                <div className={css.payheader}>
                                    <h3 className={css.sectionTitle}>
                                        Payment Methods
                                    </h3>
                                    <span className={css.paySecure}>Payments are secure and encrypted.</span>
                                </div>
                                {/* Reward Box */}
                                <div className={css.rewardBox}>
                                    <div className={css.rewardLeft}>
                                        <span className={css.rewardIcon}>
                                            <img src={rewardicon} alt="Reward Icon" />
                                        </span>
                                        <span className={css.rewardAmt}>
                                            ${orderData.totalPrepaidCreditAvailable}
                                        </span>
                                        <span className={css.rewardText}>
                                            prepaid credit available
                                        </span>
                                        <div className={css.info_wrapper}>
                                            <Tooltip
                                                title="Prepaid Credits"
                                                description="Prepaid Credits Apply Automatically.Today's payment covers the first send; upcoming mailings are billed 2 days before sending."
                                                position="bottom"
                                                bgColor="#128292"
                                                width={312}
                                                xOffset={125}
                                                yOffset={-10}
                                                arrowOffset={30}
                                            >
                                                <img src={infoicon} alt="Info Icon" className={css.infoIcon} />
                                            </Tooltip>
                                        </div>

                                    </div>

                                    <div className={css.rewardRight}>
                                        <span className={css.rewardTick}>✓</span>
                                        <span className={css.rewardApplied}>
                                            Applied
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {!hidePaymentSection && (
                                <>

                                    <div className={css.paymentDivider} />

                                    {/* Card Section */}
                                    <div className={css.cardSection}>
                                        <div className={css.paymentCard}>
                                            <CreditCardDropdown
                                                tag={false}
                                                options={cardList}
                                                paymentMethodType="Subscription"
                                                onChange={(selectedOption) =>
                                                    setSelectedCard(selectedOption)
                                                }
                                            />
                                        </div>

                                        <button
                                            className={css.addCardBtn}
                                            onClick={() => openAddPaymentPopup({})}
                                        >
                                            <img src={plusicon} alt="Plus Icon" className={css.plusIcon} />
                                            <div className={css.addCardText}>
                                                <div>Add New</div>
                                                <div>Credit Card</div>
                                            </div>
                                        </button>
                                    </div>
                                </>
                            )}
                        </div>
                        {!hidePaymentSection && (
                            <>
                                {orderData.campaignType === "MULTI" && (
                                    <div className={css.termsContainer}>
                                        <div>
                                            <label className={css.checkboxWrapper}>
                                                <CheckboxItem
                                                    checked={isChecked}
                                                    onChange={() => setIsChecked(!isChecked)}
                                                />
                                            </label>
                                        </div>

                                        <div className={css.termsText}>
                                            <span className={css.termsLabel}>
                                                I agree to the{" "}
                                                <a href="/" className={css.link}>
                                                    Terms and Conditions
                                                </a>{" "}
                                                and understand I am committing to the
                                                direct mail multiple mailer option.
                                            </span>
                                            <p>
                                                PropStream reserves the right to cancel subscription services and this license to the Client at any time for any reason at our discretion without recourse to the Client. At PropStream's sole discretion, a pro-rata refund of the monthly subscription and/or license fee paid by Client for the remaining days of the then-current month of prepaid fees may be applicable.
                                            </p>

                                            <p>
                                                The Client may cancel their subscription
                                                at any time. All fees due to PropStream
                                                up to the end of the current monthly
                                                billing cycle shall remain payable.
                                            </p>

                                            <p>
                                                Need Help? (877) 204-9040 |
                                                <a href="/" className={css.link}>
                                                    {" "}Contact Support
                                                </a>
                                            </p>
                                        </div>

                                    </div>
                                )}
                            </>
                        )}
                    </div>
                    {/* RIGHT PANEL */}
                    <div className={css.rightPanel}>
                        <h3 className={css.ordersectionTitle}>
                            Order Details
                        </h3>

                        <div className={css.orderContainer}>
                            {orderRows.map((item, index) => (
                                <div key={index} className={css.orderRow}>
                                    <span className={item.isHeader ? css.variantRow : ""}>
                                        {item.label}
                                    </span>

                                    {!item.isHeader && (
                                        <span>{item.value}</span>
                                    )}
                                </div>
                            ))}

                            <div className={css.divider} />

                            {/* SINGLE SEND */}
                            {orderData.campaignType === "SINGLE" && (
                                <>
                                    <div className={css.orderRow}>
                                        <span>Subtotal</span>
                                        <span>${orderData.totalCost}</span>
                                    </div>

                                    <div className={css.orderRow}>
                                        <span>Prepaid Credits</span>
                                        <span>-${orderData.prepaidCredit}</span>
                                    </div>

                                    <div className={css.divider} />

                                    <div className={css.totalRow}>
                                        <span>Total</span>
                                        <span>${orderData.dueToday}</span>
                                    </div>
                                </>
                            )}

                            {/* MULTI SEND */}
                            {orderData.campaignType === "MULTI" && (
                                <>
                                    <div className={css.orderRow}>
                                        <span>Total Mailers</span>
                                        <span>${totalMailers}</span>
                                    </div>

                                    <div className={css.orderRow}>
                                        <span>Total Cost</span>
                                        <span>${orderData.totalCampaignCost}</span>
                                    </div>

                                    <div className={css.orderRow}>
                                        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                            <span>Today's Charge</span>
                                            <div className={css.info_wrapper}>
                                                <Tooltip
                                                    title="Prepaid Credits"
                                                    description="Prepaid Credits Apply Automatically.Today's payment covers the first send; upcoming mailings are billed 2 days before sending."
                                                    position="top"
                                                    bgColor="#128292"
                                                    width={312}
                                                    xOffset={125}
                                                    yOffset={-140}
                                                    arrowOffset={30}
                                                >
                                                    <img src={infoicon} alt="Info Icon" className={css.infoIcon} />
                                                </Tooltip>
                                            </div>
                                        </div>
                                        <span>${orderData.todaysCharge}</span>
                                    </div>
                                    <div className={css.orderRow}>
                                        <span>Prepaid Credits</span>
                                        <span>-${orderData.prepaidCredit}</span>
                                    </div>

                                    <div className={css.divider} />

                                    <div className={css.totalRow}>
                                        <span>Due Today</span>
                                        <span>${orderData.dueToday}</span>
                                    </div>
                                </>
                            )}

                            {/* AB SPLIT */}
                            {orderData.campaignType === "SPLIT" && (
                                <>
                                    <div className={css.orderRow}>
                                        <span>Total Cost</span>
                                        <span>${orderData.totalCost}</span>
                                    </div>

                                    <div className={css.orderRow}>
                                        <span>Prepaid Credits</span>
                                        <span>-${orderData.prepaidCredit}</span>
                                    </div>

                                    <div className={css.divider} />

                                    <div className={css.totalRow}>
                                        <span>Due Today</span>
                                        <span>${orderData.dueToday}</span>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div className={css.footer}>
                    <button
                        className={css.cancelBtn}
                        onClick={onClose}
                    >
                        Cancel
                    </button>

                    <Button
                        kind={Button.kind.blue}
                        className={css.placeOrderBtn}
                        onClick={handlePlaceOrder}
                        disabled={isPlaceOrderDisabled || isPlacingOrder}
                        isLoading={isPlacingOrder}
                        spinnerColor="white"
                    >
                        Place Order
                    </Button>
                </div>
            </div>
            {showCVVModal && (
                <CVV99Modal
                    showCVVModal={showCVVModal}
                    cardEnding={selectedCard?.cardEnding}
                    cvvLength={selectedCard?.cardCVVLength}
                    handleSubmitCVV={handleSubmitCVV}
                    handleCancel={() => setShowCVVModal(false)}
                    handleClose={() => setShowCVVModal(false)}
                />
            )}
        </Modal>
    );
};

export default connect(null, {
    openAddPaymentPopup: AddPaymentPopup.open,
})(CampaginPaymentModal);